<script setup>
  defineProps({
    error: {
      type: Object,
    },
  })

  const pathname = window.location.pathname
  const segments = pathname.split("/")
  const reqCountry = segments?.at(1)
  const { locales } = useI18n()
  const detectedCountryState = useState("detectedCountry")
  const globalSettingDialog = ref(null)
  const validCountry = ref(true)
  const sameCountry = detectedCountryState.value === reqCountry

  if (sameCountry) {
    setTimeout(() => navigateTo(`/${detectedCountryState.value}`), 2000)
  } else {
    validCountry.value = !!locales.value?.find((c) => c.code == reqCountry)
    if (validCountry.value) {
      setTimeout(() => navigateTo(`/${reqCountry}`), 2000)
    }
  }

  onMounted(() => {
    if (!validCountry.value) {
      globalSettingDialog.value.showDialog()
    }
  })
</script>

<template>
  <div
    class="min-h-screen bg-gradient-to-br from-primary-500 to-primary-900 flex flex-col items-center justify-center px-4"
  >
    <div class="mb-12">
      <NuxtLink to="/">
        <Logo color="full-light" class="w-[125px] md:w-[180px]" />
      </NuxtLink>
    </div>
    <div
      class="bg-white dark:bg-gray-800 rounded-xl shadow-2xl p-8 max-w-md w-full text-center"
    >
      <div class="flex justify-center mb-6">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-16 w-16 text-gray-500"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
        >
          <path
            d="M4 9V7a2 2 0 012-2h12a2 2 0 012 2v2"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M4 15v2a2 2 0 002 2h12a2 2 0 002-2v-2"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M4 12h16"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <circle
            cx="12"
            cy="12"
            r="1"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
      <h1 class="text-4xl font-extrabold text-gray-800 dark:text-white mb-4">
        Error {{ error.statusCode }}
      </h1>
      <p class="text-md text-gray-600 dark:text-gray-300 mb-12">
        {{ error.message }}<br />
        El recurso que buscas no existe o ha sido eliminado
      </p>
      <a
        :href="`/${detectedCountryState}`"
        class="px-5 py-2 rounded-[.6rem] bg-primary-500 border border-primary-500 text-white font-medium shadow-lg hover:shadow-primary-700 ease-in transition-all"
      >
        Volver a Inicio
      </a>
    </div>
    <GlobalSettingDialog ref="globalSettingDialog" />
  </div>
</template>
